export const color_main = "rgb(101, 166, 3)"
export const color_main_text = "rgb(30, 60, 0)"
export const color_light = "rgb(255, 255, 255)"

export const color_pure_light_gray_1 = "#F5F5FA"
export const color_pure_light_gray_2 = "#EDEDF2"
export const color_pure_light_gray_3 = "#E8E8ED"
export const color_pure_light_gray_4 = "#DFDFE6"
export const color_pure_light_gray_5 = "#D2D2D9"

export const color_green_1 = "#DAEBC0"
export const color_green_2 = "#C2DB9C"
export const color_green_3 = "#A3C969"
export const color_green_4 = "#85B045"
export const color_green_5 = "#4D770E"

export const color_light_green_1 = "#FAFFF2"
export const color_light_green_2 = "#F6FCED"
export const color_light_green_3 = "#F2FAE6"
export const color_light_green_4 = "#E9F2DA"
export const color_light_green_5 = "#DAEBC0"
